module.exports = __webpack_public_path__ + "static/media/20_A.31aad0ea.png";